module.exports = __webpack_public_path__ + "img/mstile-310x310.15ec1ac5.png";